var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{staticClass:"font-weight-medium",style:({ color: _vm.statusDetail.textColor }),attrs:{"small":"","color":_vm.statusDetail.backgroundColor}},[_vm._v(" "+_vm._s(_vm.statusDetail.statusText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }